import { RouteObject } from 'react-router-dom'
import { OperationsPage } from './operations'
import { Recall } from './recall/recall'
import { OperationsMetrics } from './operations-metrics'
import { OperationsMetricsDetails } from './operations-metrics-details'
import { OperationsProvider } from './operations-context'

const OperationsWithProvider = () => {
    return (
        <OperationsProvider>
            <OperationsPage />
        </OperationsProvider>
    )
}

export const OperationsRoute: RouteObject = {
    path: '/operations',
    element: <OperationsWithProvider />,
    children: [
        {
            index: true,
            element: <OperationsMetrics />,
        },
        {
            path: 'recall',
            element: <Recall />,
        },
        {
            path: 'details',
            element: <OperationsMetricsDetails />,
        },
    ],
}
